/* eslint-disable prettier/prettier */
import { useEffect, useMemo, useRef, useState } from "react";
import translations from "../i18n/translations";
import { useLanguage } from "../context/LanguageContext";
const AMOUNT_KEY = "Amount";

<link
    href="https://fonts.googleapis.com/css2?family=Noto+Serif+Kannada:wght@400;600;700&display=swap"
    rel="stylesheet"
/>
const SHEET_URL =
    "https://opensheet.elk.sh/1SFDTeukerDFxMhUyRcOg_Twn4q5sxg24J4fQuAoo1_E/DonationList";

const amountSort = "desc"

const parseAmount = (value) => {
    if (!value) return 0;
    return Number(
        value
            .toString()
            .replace("₹", "")
            .replace(/,/g, "")
            .trim()
    );
};




export default function DonationTable() {
    const { lang } = useLanguage();
    const t = translations[lang].donations;
    const [rows, setRows] = useState([]);
    // const [search, setSearch] = useState("");
    const tableRef = useRef();

    useEffect(() => {
        fetch(SHEET_URL)
            .then(res => res.json())
            .then(data => {
                const cleaned = data.filter(
                    r => r["Devotee Name"] || r[AMOUNT_KEY]
                );

                setRows(cleaned);
            });
    }, []);

    const years = useMemo(() => {
        const set = new Set();
        rows.forEach(r => {
            if (r.Date) {
                const y = r.Date.match(/\d{4}/);
                if (y) set.add(y[0]);
            }
        });
        return [...set].sort();
    }, [rows]);

const currentYear = new Date().getFullYear().toString();
const [year, setYear] = useState(currentYear);

const filteredRows = useMemo(() => {
  const filtered = rows.filter(r => {
    const matchYear = !year || r.Date?.includes(year);
    return matchYear;
  });

  filtered.sort((a, b) => {
    const amtA = parseAmount(a[AMOUNT_KEY]);
    const amtB = parseAmount(b[AMOUNT_KEY]);
    return amountSort === "asc" ? amtA - amtB : amtB - amtA;
  });

  return filtered;
}, [rows, year, amountSort]);



    const totalAmount = filteredRows.reduce((sum, r) => {
        return sum + parseAmount(r[AMOUNT_KEY]);
    }, 0);



    return (
        <>
            <footer>
               {t.headerText}
            </footer>
            <div className="controls">
                <select value={year} onChange={e => setYear(e.target.value)}>
                    <option value="">{t.allYears}</option>
                    {years.map(y => (
                        <option key={y} value={y}>{y}</option>
                    ))}
                </select>

                {/* <input
                    placeholder={t.searchOpt}
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                /> */}
                <button onClick={() => window.print()}>
                    {t.printOpt}
                </button>

            </div>

            <div className="table-wrapper" ref={tableRef}>
                <table>
                    <thead>
                        <tr>
                            <th>{t.serialNo}</th>
                            <th>{t.yearField}</th>
                            <th>{t.devoteeName}</th>
                            <th>{t.donation}</th>
                            <th className="right">{t.amount}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredRows.map((r, i) => (
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{r.Date || "-"}</td>
                                <td>{r["Devotee Name"] || "-"}</td>
                                <td>{r.Purpose || "-"}</td>
                                <td className="right">
                                    {parseAmount(r[AMOUNT_KEY]).toLocaleString("en-IN")}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="total-card">
                {t.totalAmount}: ₹ {totalAmount.toLocaleString("en-IN")}
            </div>


        </>
    );
}
